export const formListConfig = [
    {
        title: '仓库信息',
        items: [
            {
                label: '仓库编码',
                value: '0',
                prop: 'whCode',
                type: 'span',
                disabled: true,
            },
            {
                label: '仓库状态',
                value: '0',
                prop: 'whStatus',
                optionNum: 'SRM_WH_STATUS',
                type: 'mSelect',
                disabled: true,
            },
            {
                label: '审批状态',
                value: '2',
                prop: 'approveStatus',
                type: 'mSelect',
                optionNum: 'SRM_PHY_WH_AUDIT_STATUS',
                disabled: true,
            },
            {
                label: '合同状态',
                value: '',
                prop: 'contractStatus',
                type: 'mSelect',
                optionNum: 'SYS_CONTRACT_WH_STATUS',
                disabled: true,
            },
            {
                label: '是否特批',
                value: '',
                prop: 'specialApproveFlag',
                type: 'mSelect',
                optionNum: 'SRM_SPECIAL_FLAG',
                disabled: false,
            },
            {
                label: '分公司',
                value: 'companyNameCn',
                prop: 'companyName',
                type: 'advance',
                name: '分公司',
                unfold: true,
                advanceConfig: [
                    { prop: 'companyNameCn', value: '分公司名称' },
                    { prop: 'companyCode', value: '分公司编码' },
                ],
                tableConfig: [
                    { prop: 'companyCode', value: '分公司编码' },
                    { prop: 'companyNameCn', value: '分公司名称' },
                ],
                advanceUrl: '/esCompany/popCompany',
                cbParams: ['companyCode#companyCode', 'companyNameCn#companyNameCn'],
                disabled: false,
            },
            {
                label: '单价（元/平/月）',
                value: '',
                prop: 'unitPrice',
                type: 'weightedInput',
                isPositiveNum: true,
            },
            {
                label: '联系人',
                value: '',
                prop: 'contacts',
                type: 'weightedInput',
            },
            {
                label: '联系电话',
                value: '',
                prop: 'contactsPhone',
                type: 'weightedInput',
            },
            {
                label: '城市',
                value: 'ebplNameCn',
                prop: 'cityName',
                type: 'advance',
                name: '城市',
                unfold: true,
                advanceConfig: [
                    { prop: 'ebplNameCn', value: '中文名称' },
                    { prop: 'ebplCode', value: '代码' },
                ],
                tableConfig: [
                    { prop: 'ebplCode', value: '代码' },
                    { prop: 'ebplNameCn', value: '中文名称' },
                    { prop: 'ebplNameEn', value: '英文名称' },
                ],
                advanceUrl: '/searchEbPlacePage?ebplType=PLACE_CITY&ebplIsAble=ENABLE',
                cbParams: ['ebplCode#ebplCode', 'ebplNameCn#ebplNameCn'],
                disabled: false,
            },
            {
                label: '距市区距离（km）',
                value: '',
                prop: 'cityDistance',
                type: 'input',
                disabled: false,
                isPositiveNum: true,
            },
        ],
    },
    {
        title: '仓库资质',
        items: [
            {
                label: '仓库名称',
                value: '',
                prop: 'whName',
                type: 'input',
                popover: true,
                popContent: '1、城市+园区/地产商/产权/土地租方+物流园\n2、参考公文《关于仓库命名标准化的通知》',
                disabled: false,
            },
            {
                label: '仓库地址',
                value: 'eblcDetailAddress',
                prop: 'whAddress',
                type: 'advance',
                name: '仓库地址',
                unfold: true,
                advanceConfig: [
                    { prop: 'eblcNameCn', value: '中文名称' },
                    { prop: 'eblcDetailAddress', value: '详细地址' },
                    { prop: 'eblcCode', value: '地点代码' },
                ],
                tableConfig: [
                    { prop: 'eblcCode', value: '地点代码' },
                    { prop: 'eblcNameCn', value: '中文名称' },
                    { prop: 'eblcDetailAddress', value: '详细地址' },
                ],
                advanceUrl: '/ebLocations?',
                cbParams: [
                    'eblcCode#eblcCode',
                    'eblcDetailAddress#eblcDetailAddress',
                    'eblcNameCn#eblcNameCn',
                    'eblcProvinceName#provinceName',
                    'eblcProvinceCode#provinceCode',
                    'eblcCountyName#districtName',
                    'eblcCountyCode#districtCode',
                    'eblcTownName#townName',
                    'eblcTownCode#townCode',
                    'eblcLatitude#eblcLatitude',
                    'eblcLongitude#eblcLongitude',
                ],
                disabled: false,
            },
            {
                label: '经度',
                value: '',
                prop: 'eblcLongitude',
                type: 'input',
                disabled: true,
            },
            {
                label: '纬度',
                value: '',
                prop: 'eblcLatitude',
                type: 'input',
                disabled: true,
            },
            {
                label: '产权属性',
                value: '',
                prop: 'propertyType',
                type: 'mSelect',
                options: [],
                // optionNum: 'SYS_PROPERTY_RIGHTS',
                disabled: false,
            },
            {
                label: '租期/月',
                value: '',
                prop: 'leaseTerm',
                type: 'input',
                disabled: false,
            },
            {
                label: '管理属性',
                value: '',
                prop: 'manageType',
                type: 'mSelect',
                optionNum: 'SRM_WH_MANAGE_ATTRIBUTES',
                disabled: false,
            },
            {
                label: '产权人',
                value: '',
                prop: 'propertyOwner',
                type: 'input',
                disabled: false,
            },
            {
                label: '出租方名称',
                value: '',
                prop: 'lessorName',
                type: 'input',
                disabled: false,
                popover: true,
                popContent: '需填写完整公司名称',
            },
            // {
            //     label: '承租方名称',
            //     value: '',
            //     prop: 'tenantName',
            //     type: 'input',
            //     disabled: false,
            //     popover: true,
            //     popContent: '需填写完整公司名称',
            // },
            {
                label: '土地用途',
                value: '',
                prop: 'landUse',
                type: 'mSelect',
                optionNum: 'SRM_PW_LAND_USE',
                disabled: false,
            },
            {
                label: '土地性质',
                value: '',
                prop: 'landProperty',
                type: 'mSelect',
                optionNum: 'SRM_PW_LAND_PROPERTY',
                disabled: false,
            },
            {
                label: '是否涉及转租',
                value: '',
                prop: 'isSublet',
                type: 'mSelect',
                optionNum: 'SRM_YES_NO',
                disabled: false,
            },
            {
                label: '仓库类型',
                prop: 'whType',
                value: '',
                type: 'mSelect',
                optionNum: 'SYS_SU_WH_TYPE',
                disabled: false,
            },
        ],
    },
    {
        title: '仓库硬件',
        items: [
            {
                label: '仓库建筑面积（㎡）',
                value: '',
                prop: 'whSquare',
                type: 'input',
                disabled: false,
                popover: true,
                popContent: '整个园区已报建部分面积',
                isPositiveNum: true,
            }, 
            // 加权的表单类型weightedInput
            {
                label: '安得已租赁面积(m²)',
                value: '',
                prop: 'usableArea',
                type: 'input',
                isPositiveNum: true,
                // tooltip: '所有仓库租赁生效/已归档合同的仓库面积之和',
            },
            {
                label: '剩余可租面积（㎡）',
                value: '',
                prop: 'rentableArea',
                type: 'input',
                disabled: false,
                popover: true,
                popContent: '数值限制大于0，小于(仓库建筑面积-安得已租面积)，支持两位小数点.',
                isPositiveNum: true,
            },
            {
                label: '净高（M）',
                value: '',
                prop: 'whHeight',
                type: 'input',
                disabled: false,
                isPositiveNum: true,
            },
            {
                label: '备用发电机',
                value: '',
                prop: 'poweredSystemFlag',
                type: 'mSelect',
                optionNum: 'SRM_WH_POWER_SYSTEM',
                disabled: false,
            },
            {
                label: '排水系统',
                value: '',
                prop: 'drainageSystem',
                type: 'mSelect',
                optionNum: 'SRM_DRAINAGE_SYSTEM',
                disabled: false,
            },
            // {
            //     label: '具体功率KW',
            //     value: '',
            //     prop: 'specificPower',
            //     type: 'input',
            //     hiddenInBase: true,
            // },
            {
                label: '月台',
                value: '',
                prop: 'platform',
                type: 'mSelect',
                optionNum: 'SYS_SU_PLATFORM',
                disabled: false,
            },
            {
                label: '雨棚',
                value: '',
                prop: 'canopy',
                optionNum: 'SYS_SU_CANOPY',
                type: 'mSelect',
                disabled: false,
            },
            {
                label: '雨棚宽度',
                value: '',
                prop: 'canopyWidth',
                type: 'input',
                popover: true,
                popContent: '雨棚外延宽度，即月台边到雨棚外延距离',
            },
            {
                label: '地面承压',
                value: '',
                prop: 'pressure',
                optionNum: 'SYS_SU_PRESSURE',
                type: 'mSelect',
                disabled: false,
            },
            {
                label: '建筑结构',
                value: '',
                prop: 'buildingType',
                optionNum: 'SYS_SU_BUILDING_TYPE',
                type: 'mSelect',
                disabled: false,
            },
            // {
            //     label: '采光带占比',
            //     value: '',
            //     prop: 'withLighting',
            //     type: 'mSelect',
            //     optionNum: 'SYS_SU_WITH_LIGHTING',
            //     disabled: false,
            // },
            {
                label: '地面防尘',
                value: '',
                prop: 'groundDust',
                optionNum: 'SYS_SU_GROUND_DUST',
                type: 'mSelect',
                disabled: false,
            },
            {
                label: '照明系统',
                value: '',
                prop: 'lightingSystem',
                optionNum: 'SYS_SU_LIGHTING_SYSTEM',
                type: 'mSelect',
                disabled: false,
            },
            {
                label: '作业口数量',
                value: '',
                prop: 'workPortNumber',
                type: 'input',
                popover: true,
                popContent: '可以单独进行装卸作业的停靠位',
            },
        ],
    },
    {
        title: '消防及配套相关',
        items: [
            {
                label: '消防验收',
                value: '',
                prop: 'fireInspection',
                optionNum: 'SYS_SU_FIRE_INSPECTION',
                type: 'mSelect',
                disabled: false,
            },
            {
                label: '消防设施',
                value: '',
                prop: 'fireFacilities',
                optionNum: 'SYS_SU_FIRE_FACILITIES',
                type: 'mSelect',
                disabled: false,
            },
            // {
            //     label: '消防单元面积（㎡）',
            //     value: '',
            //     prop: 'fireUnitArea',
            //     type: 'input',
            //     disabled: false,
            //     isPositiveNum: true,
            // },
            {
                label: '园区通道',
                value: '',
                prop: 'parkPath',
                optionNum: 'SYS_SU_PARK_PATH',
                type: 'mSelect',
                disabled: false,
            },
            {
                label: '办公室',
                value: '',
                prop: 'officeFlag',
                type: 'mSelect',
                optionNum: 'SRM_WH_OFFICE',
                disabled: false,
            },
            {
                label: '员工宿舍',
                value: '',
                prop: 'dormFlag',
                type: 'mSelect',
                optionNum: 'SRM_WH_DORM',
                disabled: false,
            },
            // {
            //     label: '是否地产商',
            //     value: '',
            //     prop: 'factoryFlag',
            //     type: 'mSelect',
            //     optionNum: 'SRM_YES_NO',
            // },
            {
                label: '地产商简称',
                value: '',
                prop: 'factorySign',
                type: 'mSelect',
                optionNum: 'SRM_WAREHOUSE_FACTORY_SIGN',
                // multiple: true,
            },
            {
                label: '仓库等级',
                value: '',
                prop: 'warehouseLevel',
                type: 'mSelect',
                optionNum: 'SRM_REGISTER_WAREHOUSE_LEVEL',
            },
            {
                label: '是否有产权证或报建3证',
                value: '',
                prop: 'propertyQualificationFlag',
                type: 'mSelect',
                optionNum: 'SRM_YES_NO',
            },
        ],
    },
]
